<template>
  <v-container grid-list-xl class="pa-5">
    <v-alert v-if="is_premium" class="body-2 mb-5" dense text type="info">
      Berikut ini merupakan data Laporan Persentase Kehadiran, yang telah
      digenerate berdasarkan periode yang telah dibuat. Klik
      <b>"Pratinjau"</b> untuk melakukan pratinjau proses rekap (hanya bisa
      dilakukan satu kali), atau <b>klik nama periode</b> untuk menuju halaman
      Detail Laporan Persentase Kehadiran
    </v-alert>

    <v-alert v-if="isCan('laporan.download-laporan-absen')" class="body-2 mb-5" dense text color="success" icon="mdi-information">
      Berikut ini merupakan data Rekap Absen Perdivisi yang terdiri dari :
      Jumlah WFO (IN dan OUT), Jumlah WFH (IN dan OUT), Jumlah WFA (IN dan OUT),
      Dinas Luar (IN dan OUT), Tidak Absen (IN dan OUT), CUTI, SAKIT

      <div class="text-right">
        <v-btn color="primary" small depressed @click="onDownloadRekap">
          <v-icon left>mdi-download</v-icon> Unduh Rekap
        </v-btn>
      </div>
    </v-alert>

    <m-card-list
      two-line
      title="Laporan Persentase Bulanan"
      label-cari="Cari Laporan"
      :items="items"
      @refresh="load"
      :page="page"
      footer
      @search="
        search => {
          textSearch = search;
          load();
        }
      "
      @change:page="
        pg => {
          cp = pg;
          load();
        }
      "
    >
      <template v-slot:filter>
        <div
          class="text-right"
          v-if="isCan('presensi.generate-rekap')"
          style="position:relative"
        >
          <m-button
            style="position: absolute; top:-40px; right:10px"
            dark
            small
            class="ma-2 py-4 elevation-custom"
            text="Pratinjau"
            icon="mdi-calculator"
            :large="false"
            color="orange"
            action="toGenerate"
            @toGenerate="toGenerate"
          ></m-button>
        </div>
      </template>
      <template v-slot:items="{ item }">
        <v-row class="ma-5">
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-row>
              <v-col class="py-0" cols="12" sm="12" md="6" lg="6">
                <p class="caption my-0 py-0 grey--text align-left">Periode</p>
                <m-button
                  small
                  color="white"
                  class="elevation-0 flat primary--text body-1 font-weight-regular text-capitalize btn-block"
                  action="toDetil"
                  @toDetil="toDetil(item)"
                  :text="item.nama"
                >
                </m-button>
              </v-col>
              <v-col class="py-0" cols="12" sm="12" md="3" lg="3">
                <p class="caption my-0 py-0 grey--text align-left">Aksi</p>

                <!-- <m-button
                  class="elevation-5 ma-1"
                  color="success"
                  icon="mdi-clipboard-list-outline"
                  text="Detail Rekap"
                  action="toDetil"
                  @toDetil="toDetil(item)"
                ></m-button> -->
                <m-button
                  v-if="isCan('presensi.generate-rekap')"
                  class="py-4  elevation-custom"
                  color="success"
                  dark
                  small
                  icon="mdi-reload"
                  text="Perbarui"
                  action="toDetil"
                  @toDetil="toCheckGenerate(item)"
                ></m-button>
              </v-col>
              <v-col class="py-0" cols="12" sm="12" md="3" lg="3">
                <template v-if="item && item.log_proses_rekaps[0]">
                  <p class="caption my-0 py-0 grey--text align-left">Log Akses</p>
                  <div class="text-muted"><span class="grey--text"> Waktu Proses:</span> {{ item.log_proses_rekaps[0]['wkt_proses'] }}</div>
                  <div class="text-muted"><span class="grey--text"> Oleh:</span> {{ item.log_proses_rekaps[0]['users']['nama'] }}</div>
                </template>

              </v-col>
              <v-col cols="12" class="mb-0 pb-0 mt-2">
                <v-divider class="mb-0 pb-0"></v-divider>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </template>
    </m-card-list>
    <m-dialog ref="blocking" title="Informasi Penting" :fullscreen="false">
      <div class="black--text pa-2">
        <p>
          Pada periode yang akan diproses, terdapat ajuan cuti yang statusnya masih <b>MENUNGGU</b>.
          Jika belum diverval (Disetujui/Ditolak). Maka presensinya dianggap Tidak Hadir/Alpha.
          Sehingga memengaruhi persentase kehadiran. Sebainya lakukan pengecekan terhadap cuti dengan status menunggu.
          Dan mintalah Level yang lebih atas, untuk verval
        </p>
      </div>

      <div v-for="(aproval, a) in cutiBelumSetuju" :key="a">
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-row>
                <v-col cols="12" md="1">
                  <v-avatar :size="40" color="grey lighten-4">
                    <v-img
                      src="img/cowok.png"
                      alt="avatar"
                    />
                  </v-avatar>
                </v-col>
                <v-col cols="12" md="4" sm="12">
                  {{ getDeepObj(aproval, 'users.nama') }}<br/>
                  <span class="caption">{{ getDeepObj(aproval, 'keterangan') }}</span>
                </v-col>
                <v-col cols="12" md="3" sm="12">
                  {{ duration(getDeepObj(aproval, 'tgl_awal'), getDeepObj(aproval, 'tgl_akhir')) }}
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider />
      </div>
      <template v-slot:card-action>
        <v-toolbar flat>
          <v-toolbar-title></v-toolbar-title>
          <v-spacer/>
          <div>
            <v-btn depressed text class="primary--text" @click="$refs.blocking.reject()">Batal</v-btn>
            <v-btn depressed color="primary" @click="toGenerate(itemSelected)">Lanjutkan</v-btn>
          </div>
        </v-toolbar>
      </template>
    </m-dialog>
  </v-container>
</template>

<script>
import { duration } from "../../../tools";
export default {
  components: {},
  data: () => ({
    periode: [],
    items: [],
    cutiBelumSetuju: [],
    itemSelected: {},
    textSearch: null,
    page: null,
    cp: 1,
    headers: [
      { text: "Nama", align: "left", value: "nama" },
      { text: "Hadir", align: "center", value: "hadir" },
      { text: "Ketidakhadiran", align: "center", value: "cuti" },
      { text: "Alpa", align: "center", value: "absen" },
      { text: "Persentase Kehadiran", align: "center", value: "persentase" }
    ]
  }),
  activated() {
    this.load();
    this.loadPeriode();
    this.loadKategoriKetidakhadiran();
  },
  methods: {
    duration,
    loadPeriode() {
      this.$store
        .dispatch("periode/get", {
          organisasi_id: this.organisasi_id,
          params: {
            page: this.cp
          }
        })
        .then(res => {
          this.periode = res.data.data;
        })
        .catch(e => e);
    },
    toCheckGenerate(obj) {
      this.itemSelected = obj || {}
      this.cutiBelumSetuju = []
      this.$store.dispatch('laporan/cekSetuju', {
        params: {
          tgl_mulai: obj.tgl_mulai,
          tgl_akhir: obj.tgl_selesai,
        },
        organisasi_id: this.organisasi_id,
      }).then(({ data }) => {
        this.cutiBelumSetuju = (data && data.data) || []

        if (this.cutiBelumSetuju.length > 0) {
          this.$refs.blocking.open();
        } else {
          this.toGenerate(this.itemSelected)
        }
      })
    },
    toGenerate(obj) {
      if (obj) {
        this.$confirmDanger(
          `Apakah Anda yakin akan memproses ulang Laporan Persentase Kehadiran periode
          ini?
          <center style="font-size:16pt; margin:10px; font-weight:bold">${obj.nama}</center>
          `,
          {},
          "Proses Laporan Persentase Kehadiran"
        )
          .then(() => {
            this.$store
              .dispatch("laporan/generateRekap", {
                organisasi_id: this.organisasi_id,
                periode_laporan_id: obj.periode_laporan_id,
                is_hitung_ulang: 0
              })
              .then(res => {
                if (res) {
                  this.$info(
                    "Proses Rekapitulasi Ulang Persentase Kehadiran Periode " +
                      obj.nama +
                      " berhasil"
                  );
                  this.load();
                } else {
                  this.$error(
                    "Proses Rekapitulasi Ulang Persentase Kehadiran Periode " +
                      obj.nama +
                      " gagal"
                  );
                }
              });
          })

          .catch(e => e);
      } else {
        this.$confirmDanger(
          `<div class="ma-1 mb-4 mt-2 pb-2 row red lighten-5 red--text rounded">

            <i class="ma-3 v-icon v-alert__icon mdi mdi-information red--text"></i>

          <div class="col m11 pa-1 pt-3">
            Catatan: Jika tidak tampil, maka periode laporan sudah pernah diproses. Silakan lakukan proses perbarui data saja
          </div>
        </div>

          <p>Pilih periode laporan yang akan diproses</p>`,
          {
            periode: this.periode
          },
          "Proses Laporan Persentase Kehadiran"
        )
          .then(res => {
            this.$store
              .dispatch("laporan/generateRekap", {
                organisasi_id: this.organisasi_id,
                periode_laporan_id: res.periode.periode_laporan_id,
                is_hitung_ulang: 0
              })
              .then(res => {
                if (res) {
                  this.$info("Proses Rekapitulasi Kehadiran Periode berhasil");
                  this.load();
                } else {
                  this.$error("Proses Rekapitulasi Kehadiran Periode gagal");
                }
              });
          })

          .catch(e => e);
      }
    },
    load() {
      this.$store
        .dispatch("laporan/persentaseKehadiran", {
          organisasi_id: this.organisasi_id,
          params: {
            page: this.cp,
            keyword: this.textSearch,
            is_log_rekap: 1
          }
        })
        .then(res => {
          this.page = res.data;
          this.items = res.data.data;
        })
        .catch(e => e);
    },
    toDetil(item) {
      if (!this.isCan("presensi.detail-rekap")) return;
      this.$router.push({
        name: "laporan.kehadiran.detil",
        params: {
          organisasi_id: this.organisasi_id,
          periode_laporan_id: item.periode_laporan_id
        }
      });
    },
    loadKategoriKetidakhadiran() {
      this.kategoriKetidakhadiran = [
        {
          id: 1,
          satuan: "menit",
          nama: "Skor 1 (10-30)",
          batas_atas: 10,
          batas_bawah: 30,
          presentase: 0.5
        },
        {
          id: 2,
          satuan: "menit",
          nama: "Skor 2 (31-60)",
          batas_atas: 31,
          batas_bawah: 60,
          presentase: 1
        },
        {
          id: 3,
          satuan: "menit",
          nama: "Skor 3 (61-90)",
          batas_atas: 61,
          batas_bawah: 90,
          presentase: 1.3
        },
        {
          id: 4,
          satuan: "menit",
          nama: "Skor 4 (>90)",
          batas_atas: 90,
          batas_bawah: 120,
          presentase: 1.5
        },
        {
          id: 5,
          satuan: "hari",
          nama: "Skor 5 (TMK)",
          batas_atas: 480,
          batas_bawah: 1440,
          presentase: 3
        },

        {
          id: 6,
          satuan: "hari",
          nama: "Sakit Tanpa Keterangan",
          batas_atas: 480,
          batas_bawah: 1440,
          presentase: 3
        }
      ];
    },
    countLostTimeCategori(value, percent) {
      return (((value * percent) / 100) * 100).toFixed(1);
    },
    totalPresentaseKeterlambatan(item) {
      var totalPercent = 0;
      item.forEach(i => {
        totalPercent = totalPercent + i.presentase * i.jumlah;
      });
      return totalPercent;
    },
    onDownloadRekap() {
      this.$store.dispatch('laporan/unduhLaporanAbsen', { organisasi_id: this.current_organisasi.organisasi_id })
        .then((resp) => {
        window.open(resp)
      })
    }
  }
};
</script>
<style>
#rekap {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#rekap td,
#rekap th {
  border: 1px solid #ddd;
  padding: 8px;
}

#rekap tr:nth-child(even) {
  background-color: #f2f2f2;
}

#rekap tr:hover {
  background-color: #ddd;
}

#rekap th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: center;
  color: white;
}
.elevation-custom {
  -webkit-box-shadow: 0px 2px 12px 3px #1136a356 !important;
}
</style>
